import React from 'react';
import styled from 'styled-components';

import Container from 'components/Container';
import RichText from 'components/RichText';
import ShareLinks from 'components/ShareLinks';
import Stack from 'components/Stack';
import TableOfContents from 'components/TableOfContents';
import { PostShape } from 'utils/props';
import { color, media } from 'styles/utils';
import { PAGE_REGIONS, getPageRegionProps } from 'utils';

import PostTags from './PostTags';
import GetDemo from './GetDemo';

const StyledSection = styled.section`
  background-color: ${color('bgBlueGray')};
  padding: 10rem 1.5rem 4.5rem 1.5rem;
`;

const StyledContainer = styled(Container)`
  display: grid;
  column-gap: 2rem;
  grid-template-columns: 20% 1fr 20%;
  ${media.max('lg')} {
    grid-template-columns: 1fr;
  }
`;

const StyledWing = styled.aside`
  ${media.max('lg')} {
    display: none;
  }
`;

const StickyContainer = styled.div`
  position: sticky;
  top: calc(var(--sleuth-safe-area-inset-top, 0) + 2rem);
`;

const MobileOnly = styled(Stack)`
  margin: 2rem 0;
  ${media.min('lg')} {
    display: none;
  }
`;

export default function PostBody({ post }) {
  const contentSections = post.body
    .filter((i) => ['h1', 'h2', 'h3', 'h4'].includes(i.style))
    .map((i) => ({
      key: i._key,
      text: i.children[0].text,
    }));

  return (
    <StyledSection>
      <StyledContainer size="lg">
        <StyledWing>
          <StickyContainer>
            <TableOfContents title={post.title} items={contentSections} />
          </StickyContainer>
        </StyledWing>

        <div>
          <RichText value={post.body} />
        </div>

        <StyledWing {...getPageRegionProps(PAGE_REGIONS.right_rail)}>
          <StickyContainer>
            <Stack gap="2.5rem">
              <PostTags post={post} />
              <ShareLinks post={post} />
              <GetDemo />
            </Stack>
          </StickyContainer>
        </StyledWing>
      </StyledContainer>

      <MobileOnly gap="2rem">
        <PostTags post={post} />
        <ShareLinks post={post} />
      </MobileOnly>
    </StyledSection>
  );
}

PostBody.propTypes = {
  post: PostShape,
};
